import DOMPurify from "dompurify";

const HTMLSanitize = {
  install(Vue) {
    Vue.directive("safe-html", {
      inserted: function (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value);
      },
      update: function (el, binding) {
        el.innerHTML = DOMPurify.sanitize(binding.value);
      }
    });
  }
};

export default HTMLSanitize;
